<template>
  <div @keyup.enter="handleSearch(false)">
    <div style="position: relative; top: 60px;">
      <h1 style="text-align: center;">消防法律法规库</h1>
       <div style="text-align: center; margin-top: 10px; color: #666; font-size: 14px; line-height: 1.5;">
        消防法律法规库，涵盖4790部涉及到消防的法律法规，不包含各类标准规范，欢迎使用并反馈修改意见。
      </div>
      <div style="text-align: center; color: #666;margin-top: 10px; font-size: 14px; line-height: 1.5;">
  联系人：<span style="color: #666; font-size: 14px; line-height: 1.5;">姚浩伟</span>，<span style="color: #0000FF;">13937136590</span>，<span style="color: #0000FF;">haowei.yao@qq.com</span>
</div>
    </div>
    <div class="search-container" style="margin-top: 160px;">
      <input
          type="text"
          id="search-input"
          v-model="searchQuery"
          :placeholder="searchType === 'both' ? '请输入搜索关键字' : '请输入搜索关键字'"
          @keyup.enter="handleSearch(false)"
      />
      <button class="search-btn" @click="handleSearch(false)">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16"
        >
          <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
          />
        </svg>
      </button>
      <button class="advanced-btn" @click="toggleAdvancedOptions">
        高级检索
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-down"
            viewBox="0 0 16 16"
        >
          <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
          />
        </svg>
      </button>
    </div>
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <div class="advanced-options" v-if="showAdvancedOptions">
      <div class="advanced-buttons" style="display: flex; justify-content: flex-end; gap: 16px; margin-top: 24px; padding-top: 16px; border-top: 1px solid #f5f5f5;">
        <button class="reset-btn" @click="resetAdvancedOptions">重置</button>
        <button class="cancel-btn" @click="toggleAdvancedOptions">取消</button>
        <button class="confirm-btn" @click="confirmAdvancedOptions">确定</button>
      </div>
      <!-- 新增flex行容器 -->
      <div class="row-group">
        <!-- 检索范围 -->
        <div class="option-group" style="flex: 1; border-bottom: none;">
          <span class="search-range-label">检索范围：</span>
          <div class="input-group">
            <label>
              <input type="radio" name="search-type" value="title" v-model="searchType" /> 标题
            </label>
            <label>
              <input type="radio" name="search-type" value="file" v-model="searchType" /> 正文
            </label>
            <label>
              <input type="radio" name="search-type" value="both" v-model="searchType" /> 标题+正文
            </label>
          </div>
        </div>

        <!-- 检索方式 -->
        <div class="option-group" style="flex: 1; border-bottom: none;">
          <span class="search-range-label">检索方式：</span>
          <div class="input-group">
            <label>
              <input type="radio" name="search-mode" value="exact" v-model="searchMode" /> 精确查询
            </label>
            <label>
              <input type="radio" name="search-mode" value="fuzzy" v-model="searchMode" /> 模糊查询
            </label>
          </div>
        </div>
      </div>

      <!-- 公布日期 -->
      <div class="option-group">
        <span class="search-range-label">公布日期：</span>
        <div class="input-group">
          <input type="date" v-model="effectiveStartDate" style="margin: 0 4px;" />
          <span>至</span>
          <input type="date" v-model="effectiveEndDate" style="margin: 0 4px;" />
        </div>
      </div>

      <!-- 施行日期 -->
      <!-- <div class="option-group">
        <span class="search-range-label">施行日期：</span>
        <div class="input-group">
          <input type="date" v-model="promulgationStartDate" style="margin: 0 4px;" />
          <span>至</span>
          <input type="date" v-model="promulgationEndDate" style="margin: 0 4px;" />
        </div>
      </div> -->

      <!-- 时效性 -->
      <div class="option-group">
        <span class="search-range-label">时效性：</span>
        <div class="input-group checkbox-group">
          <label>
            <input type="checkbox" name="validity-status" value=2 v-model="validityStatus" /> 尚未生效
          </label>
          <label>
            <input type="checkbox" name="validity-status" value=1 v-model="validityStatus" /> 有效
          </label>
          <label>
            <input type="checkbox" name="validity-status" value=3 v-model="validityStatus" /> 已修改
          </label>
          <label>
            <input type="checkbox" name="validity-status" value=0 v-model="validityStatus" /> 已废止
          </label>
        </div>
      </div>


      <div class="row-group">
        <!-- 制定机关 -->
        <div class="option-group" style="flex: 1; border-bottom: none;">
          <span class="search-range-label">制定机关：</span>
          <div class="input-group">
            <div class="agency-selector">
              <div class="agency-header" @click="toggleMainAgencyDropdown">
                {{ selectedAgencyText || '请选择制定机关' }}
                <span class="arrow">{{ showMainAgencyDropdown ? '▲' : '▼' }}</span>
              </div>
              <!-- 主机构下拉 -->
              <div class="main-dropdown" v-show="showMainAgencyDropdown">
                <div
        class="agency-item"
        v-for="agency in mainAgencies"
        :key="agency.id"
        :class="{ 'has-children': agency.hasChildren }"
    >
      <!-- 将复选框和名称分离为独立点击区域 -->
      <span 
          class="custom-checkbox" 
          :class="{ checked: agency.checked }"
          @click.stop="handleAgencyCheckboxClick(agency)"
      >✓</span>
      <span 
          class="agency-name"
          @click.stop="handleAgencyNameClick(agency)"
      >{{ agency.name }}</span>
                  <!-- 子机构下拉（当有子机构时显示） -->
                  <div
                      class="sub-dropdown"
                      v-show="showSubAgencyDropdown && currentMainAgency?.id === agency.id"
                  >
                    <div
                        class="sub-item"
                        v-for="item in (agency.id === '全国人民代表大会及其常务委员会' ? npcSubAgencies : localSubAgencies)"
                        :key="item.id"
                        @click="handleSubAgencyClick(agency, item)"
                    >
                      <span class="custom-checkbox" :class="{ checked: item.checked }">✓</span>
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 法律效力位阶 -->
        <div class="option-group"  style="flex: 1; border-bottom: none;">
          <span class="search-range-label">法律效力位阶：</span>
          <div class="input-group">
            <div class="legal-level-selector">
              <div class="agency-header" @click="toggleLegalLevelDropdown">
                {{ selectedLegalLevelText || '请选择法律效力位阶' }}
                <span class="arrow">{{ showLegalLevelDropdown ? '▲' : '▼' }}</span>
              </div>
              <!-- 主选项下拉 -->
              <div class="main-dropdown" v-show="showLegalLevelDropdown">
                <div
                    class="agency-item"
                    v-for="level in legalLevelMain"
                    :key="level.id"
                    @click="handleLegalLevelClick(level)"
                    :class="{ 'has-children': level.hasChildren }"
                >
                  <!-- 无子选项的显示复选框 -->
                  <span
                      class="custom-checkbox"
                      :class="{ checked: level.checked }"
                      v-if="!level.hasChildren"
                  >✓</span>
                  {{ level.name }}
                  <!-- 子选项下拉（当有子选项时显示） -->
                  <div
                      class="sub-dropdown"
                      v-show="showSubLegalLevelDropdown && currentLegalLevel?.id === level.id"
                  >
                    <div
                        class="sub-item"
                        v-for="sub in legalLevelSub[level.id]"
                        :key="sub.id"
                        @click="handleSubLegalLevelClick(level, sub)"
                    >
                      <span class="custom-checkbox" :class="{ checked: sub.checked }">✓</span>
                      {{ sub.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 搜索结果表格 -->
  <div class="search-results" v-if="hasSearched && !isSearching">
    <table class="result-table">
      <thead>
      <tr>
        <th width="8%">序号</th>
        <th width="25%">标题</th>
        <th width="20%">制定机关</th>
        <th width="15%">法律性质</th>
        <th width="12%">时效性</th>
        <th width="20%">公布日期</th>
      </tr>
      </thead>
      <tbody>
      <!-- 有结果时显示数据行 -->
      <template v-for="(result, index) in searchResults" :key="index">
        <tr
            @click="navigateToDetail(result.id)"
            style="cursor: pointer;"
        >
          <td>{{ (pageInfo.pageNum - 1) * pageInfo.pageSize + index + 1 }}</td>
          <td>{{ result.title }}</td>
          <td>{{ result.promulgatingAgency }}</td>
          <td>{{ result.lawType }}</td>
          <td>{{ result.isActiveDesc }}</td>
          <td>{{ result.effectiveDate }}</td>
        </tr>
        <!-- 正文检索时显示匹配条款 -->
        <tr v-if="(searchType === 'file' || searchType === 'both') && result.matchedClauses && result.matchedClauses.trim() !== ''">
  <td colspan="6" class="keyword-context">
    <div v-html="formatClauseContext(result.matchedClauses, searchQuery)"></div>
  </td>
</tr>
      </template>
      <tr v-if="searchResults.length === 0">
        <td colspan="6" class="no-results-cell">
          未找到有关{{ searchQuery }}相关的法律
        </td>
      </tr>
      </tbody>
    </table>
    <div class="results-header">
      <h3 v-if="searchResults.length > 0" class="result-title"> (共{{ pageInfo.total }}条结果)</h3>
      <!-- 分页组件 -->
      <div class="pagination" v-if="hasSearched && pageInfo.total > 0">
        <button @click="changePage(1)" :disabled="pageInfo.pageNum === 1">首页</button>
        <button @click="changePage(pageInfo.pageNum - 1)" :disabled="pageInfo.pageNum === 1">上一页</button>
        <span>第 {{ pageInfo.pageNum }} 页，共 {{ pageInfo.pages }} 页</span>
        <button @click="changePage(pageInfo.pageNum + 1)" :disabled="pageInfo.pageNum === pageInfo.pages">下一页</button>
        <button @click="changePage(pageInfo.pages)" :disabled="pageInfo.pageNum === pageInfo.pages">尾页</button>
        <span>到第</span>
        <input
            type="number"
            v-model="targetPage"
            min="1"
            :max="pageInfo.pages"
            placeholder="页码"
            @keyup.enter="goToPage"
            class="page-input"
        />
        <span>页</span>
        <button @click="goToPage" class="go-btn">确定</button>
      </div>
    </div>
  </div>
  <div class="loading" v-if="isSearching">搜索中...</div>
</template>
<script>
import searchApi from '@/api/search';

export default {
  mounted() {
    document.addEventListener('click', (e) => {
      // 获取制定机关和法律效力位阶的选择器元素
      const agencySelector = document.querySelector('.agency-selector');
      const legalLevelSelector = document.querySelector('.legal-level-selector');

      // 检查点击目标是否在任意一个选择器内部
      const isInsideAgency = agencySelector?.contains(e.target);
      const isInsideLegalLevel = legalLevelSelector?.contains(e.target);

      // 若不在制定机关选择器内部，关闭其下拉框
      if (!isInsideAgency) {
        this.showMainAgencyDropdown = false;
        this.showSubAgencyDropdown = false;
        this.currentMainAgency = null;
      }

      // 若不在法律效力位阶选择器内部，关闭其下拉框
      if (!isInsideLegalLevel) {
        this.showLegalLevelDropdown = false;
        this.showSubLegalLevelDropdown = false;
        this.currentLegalLevel = null;
      }
    });
    this.updatePromulgatingAgency();
    this.updateSelectedAgencyText();
    this.updateLegalLevelTextAndParams();
  },
  name: 'SearchComponent',
  data() {
    return {
      searchQuery: '',
      showAdvancedOptions: false,
      searchType: 'both',
      searchMode: 'fuzzy', // 检索方式：exact(精确)/fuzzy(模糊)
      targetPage: '',
      pageInfo: {
        pageNum: 1,            // 当前页码
        pageSize: 10,          // 每页数量
        total: 0,              // 总记录数
        pages: 0,               // 总页数
      },          // 分页信息（总页数、总条数等）
      isSearching: false,
      isUpdatingRoute: false,
      searchResults: [],// 需与后端返回的字段严格匹配
      errorMessage: '',
      hasSearched: false, // 记录是否执行过搜索
      tooltipVisible: false,
      tooltipX: 0,
      tooltipY: 0,
      currentResult: null,  // 记录当前悬停的法律条目
      // 新增高级筛选字段
      effectiveStartDate: null, // 实行日期开始
      effectiveEndDate: null,   // 实行日期结束
      promulgationStartDate: null, // 公布日期开始
      promulgationEndDate: null,   // 公布日期结束
      validityStatus: [1],
      promulgatingAgency: '', // 制定机关
      selectedAgencyText: '', // 显示选中的机构文本
      showMainAgencyDropdown: false, // 是否显示主下拉框
      showSubAgencyDropdown: false, // 是否显示子下拉框
      currentMainAgency: null, // 当前操作的主机构
      legalLevel: [], // 法律效力位阶
      // 主机构列表
      mainAgencies: [
        { id: '全国人民代表大会及其常务委员会', name: '全国人大及其常委会', hasChildren: true, checked: true },
        { id: '国务院', name: '国务院', hasChildren: false, checked: true }, 
        { id: '国家监察委员会', name: '国家监察委员会', hasChildren: false, checked: true },
        { id: '最高人民法院', name: '最高人民法院', hasChildren: false, checked: true },
        { id: '最高人民检察院', name: '最高人民检察院', hasChildren: false, checked: true },
        { id: '地方人大及其常委会', name: '地方人大及其常委会', hasChildren: true, checked: false }
      ],
      // 全国人大及其常委会子机构
      npcSubAgencies: [
        { id: 'npc_all', name: '全选', checked: true },
        { id: '全国人民代表大会', name: '全国人大', checked: true },
        { id: '全国人民代表大会常务委员会', name: '全国人大常委会', checked: true }
      ],
      // 地方人大及其常委会子机构
      localSubAgencies: [
        { id: 'local_all', name: '全选', checked: false },
  { id: '北京市', name: '北京' },
  { id: '天津市', name: '天津' },
  { id: '河北省', name: '河北' },
  { id: '山西省', name: '山西' },
  { id: '内蒙古自治区', name: '内蒙古' },
  { id: '辽宁省', name: '辽宁' },
  { id: '吉林省', name: '吉林' },
  { id: '黑龙江省', name: '黑龙江' },
  { id: '上海市', name: '上海' },
  { id: '江苏省', name: '江苏' },
  { id: '浙江省', name: '浙江' },
  { id: '安徽省', name: '安徽' },
  { id: '福建省', name: '福建' },
  { id: '江西省', name: '江西' },
  { id: '山东省', name: '山东' },
  { id: '河南省', name: '河南' },
  { id: '湖北省', name: '湖北' },
  { id: '湖南省', name: '湖南' },
  { id: '广东省', name: '广东' },
  { id: '广西壮族自治区', name: '广西' },
  { id: '海南省', name: '海南' },
  { id: '重庆市', name: '重庆' },
  { id: '四川省', name: '四川' },
  { id: '贵州省', name: '贵州' },
  { id: '云南省', name: '云南' },
  { id: '西藏自治区', name: '西藏' },
  { id: '陕西省', name: '陕西' },
  { id: '甘肃省', name: '甘肃' },
  { id: '青海省', name: '青海' },
  { id: '宁夏回族自治区', name: '宁夏' },
  { id: '新疆维吾尔自治区', name: '新疆' },
      ],
      legalLevelMain: [
        { id: '宪法', name: '宪法', hasChildren: false, checked: true },
        { id: '法律', name: '法律', hasChildren: false, checked: true }, 
        { id: '行政法规', name: '行政法规', hasChildren: false, checked: true },
        { id: '监察法规', name: '监察法规', hasChildren: false, checked: true },
        { id: '地方法规', name: '地方法规', hasChildren: false, checked: true },
        { id: '司法解释', name: '司法解释', hasChildren: false, checked: true },
        { id: '部门规章', name: '规范性文件', hasChildren: false, checked: true },
        { id: '修改、废止的决定', name: '修改、废止的决定', hasChildren: false, checked: true }
      ],
      legalLevelSub: {
      },
      showLegalLevelDropdown: false, // 主下拉框显示状态
      showSubLegalLevelDropdown: false, // 子下拉框显示状态
      currentLegalLevel: null, // 当前操作的主选项
      selectedLegalLevelText: '', // 显示的选中文本
      legalLevelParams: '' ,// 最终传递给接口的参数
      isLocalAgencySearch: false,
      localProvinceParams: '',
    };
  },
  computed:{
    splitClauses() {
      if (!this.lawDetail || !this.lawDetail.content) return [];
      // 修改正则：支持数字和汉字条款号
      const clauseRegex = /^\s*第([零一二三四五六七八九十百千万]+|\d+)条[:：]\s*/gm;
      const clauses = [];
      let match;
      // 遍历所有"第X条"匹配项
      while ((match = clauseRegex.exec(content)) !== null) {
        const clauseNumber = match[1];
        const clauseStart = match.index + match[0].length;
        const nextMatch = clauseRegex.exec(content);
        const clauseEnd = nextMatch ? nextMatch.index : content.length;
        const clauseContent = content.substring(clauseStart, clauseEnd).trim();

        if (clauseContent) {
          clauses.push({
            number: clauseNumber,
            content: clauseContent
          });
        }
      }
      console.log('拆分后的条款数组:', clauses);
      return clauses;
    },
    keywordClauses() {
      const encodedKeyword = this.$route.query.keyword;
      if (!encodedKeyword) return []; // 无关键字时返回空
      const keyword = decodeURIComponent(encodedKeyword);

      // 从拆分的条款中筛选包含关键字的条款
      return this.splitClauses
          .filter(clause =>
              clause.content.includes(keyword) || clause.number.includes(keyword)
          )
          .map(clause => `${clause.number}条：${clause.content.trim()}`); // 格式化为"条款号：内容"
    }
  },
  watch: {
    $route: {
    handler(newRoute) {
      if (this.isUpdatingRoute) {
        this.isUpdatingRoute = false;
        return;
      }
      const {
        keyword,
        type,
        pageNum,
        pageSize,
        searchMode,
        effectiveStartDate,
        effectiveEndDate,
        promulgationStartDate,
        promulgationEndDate,
        validityStatus,
        promulgatingAgency,
        legalLevelParams,
        isLocalAgencySearch,
        localProvinceParams,
        showAdvancedOptions
      } = newRoute.query;
      if (keyword) {
        // 更新搜索条件
        this.searchQuery = keyword;
        this.searchType = type || 'title';
        this.pageInfo.pageNum = parseInt(pageNum) || 1;
        this.pageInfo.pageSize = parseInt(pageSize) || 10;
        this.searchMode = searchMode || this.searchMode;
        this.effectiveStartDate = effectiveStartDate || null;
        this.effectiveEndDate = effectiveEndDate || null;
        this.promulgationStartDate = promulgationStartDate || null;
        this.promulgationEndDate = promulgationEndDate || null;
        this.validityStatus = validityStatus ? validityStatus.split(',') : [];
        // 恢复高级检索界面状态
        this.showAdvancedOptions = showAdvancedOptions === 'true' || false;
        // 恢复地方人大相关参数
        this.isLocalAgencySearch = isLocalAgencySearch === 'true' || false;
          this.localProvinceParams = localProvinceParams ? decodeURIComponent(localProvinceParams) : '';
        // 直接设置promulgatingAgency和legalLevelParams，而不是空字符串
        this.promulgatingAgency = promulgatingAgency ? decodeURIComponent(promulgatingAgency) : this.promulgatingAgency;
        this.legalLevelParams = legalLevelParams || this.legalLevelParams;
        // 触发搜索
        if (promulgatingAgency) {
            this.restoreAgencySelections(
              decodeURIComponent(promulgatingAgency),
              this.isLocalAgencySearch,  // 传递isLocalAgencySearch状态
              this.localProvinceParams   // 传递localProvinceParams参数
            );
          } else {
            this.restoreAgencySelections(
              '',
              this.isLocalAgencySearch,  // 传递isLocalAgencySearch状态
              this.localProvinceParams   // 传递localProvinceParams参数
            );
          }
        if (legalLevelParams) {
          this.restoreLegalLevelSelections(decodeURIComponent(legalLevelParams));
        }
        this.handleSearch(false);
      }
    },
    immediate: true, // 初始化时立即执行一次（处理首次加载的参数）
    deep: true       // 深度监听query对象变化
  },
    searchType(newVal) {
      // 当检索范围切换为「正文」时，自动设置为模糊查询
      if (newVal === 'file') {
        this.searchMode = 'fuzzy';
      }
    },
    searchQuery(newVal) {
      // 当搜索框内容为空时重置搜索状态
      if (!newVal.trim()) {
        this.resetSearchState();
      }
    }
  },
  methods: {
    restoreAgencySelections(agencyStr, isLocalAgencySearch, localProvinceParams) {
       this.mainAgencies.forEach(agency => {
    agency.checked = false;
  });
  
  this.npcSubAgencies.forEach(sub => {
    sub.checked = false;
  });
  
  this.localSubAgencies.forEach(sub => {
    sub.checked = false;
  });
  
  // 确保正确解析布尔值参数
  const isLocalSearch = isLocalAgencySearch === 'true' || isLocalAgencySearch === true;
  
  // 优先处理地方人大搜索模式
  if (isLocalSearch && localProvinceParams) {
    // 恢复地方人大状态
    this.isLocalAgencySearch = true;
    this.localProvinceParams = localProvinceParams;
    
    const localAgency = this.mainAgencies.find(a => a.id === '地方人大及其常委会');
    if (localAgency) {
      localAgency.checked = true;
      // 恢复选中的省份
      const provinces = localProvinceParams.split(',');
      this.localSubAgencies.forEach(item => {
        if (provinces.includes(item.id)) {
          item.checked = true;
        }
      });
      // 处理全选状态
      this.handleSubItemCheck(localAgency);
    }
  }

      // 然后从agencyStr恢复其他选中状态
      if (agencyStr) {
        const agencyIds = agencyStr.split(',');

        // 无子机构的主机构选择
        this.mainAgencies.forEach(agency => {
          if (!agency.hasChildren && agencyIds.includes(agency.id)) {
            agency.checked = true;
          }
        });

        // 全国人大及其常委会子机构选择
        const npcAgency = this.mainAgencies.find(a => a.id === '全国人民代表大会及其常务委员会');
        if (npcAgency) {
          let hasCheckedSub = false;
          this.npcSubAgencies.forEach(sub => {
            if (agencyIds.includes(sub.id)) {
              sub.checked = true;
              hasCheckedSub = true;
            }
          });
          // 如果有任何子机构被选中，则主机构也应被选中
          if (hasCheckedSub) {
            npcAgency.checked = true;
          }
        }
      }

      this.updateSelectedAgencyText();
      this.updatePromulgatingAgency(true); // 传入true以保持地方人大状态
    },

    // 从路由参数恢复法律效力位阶选择状态
    restoreLegalLevelSelections(legalLevelStr) {
      if (!legalLevelStr) return;

      const legalLevelIds = legalLevelStr.split(',');

      // 重置所有选中状态
      this.legalLevelMain.forEach(level => {
        level.checked = false;
      });

      // 恢复法律效力位阶选择
      this.legalLevelMain.forEach(level => {
        if (legalLevelIds.includes(level.id)) {
          level.checked = true;
        }
      });

      this.updateLegalLevelTextAndParams();
    },
    resetAdvancedOptions() {
  // 重置检索范围和方式
  this.searchType = 'both';
  this.searchMode = 'fuzzy';

  // 重置日期范围
  this.effectiveStartDate = null;
  this.effectiveEndDate = null;
  this.promulgationStartDate = null;
  this.promulgationEndDate = null;

  // 重置时效性选择为默认值（有效）
  this.validityStatus = [1];

  // 重置制定机关选择为默认值
  this.promulgatingAgency = '';
  this.selectedAgencyText = '';
  
  // 恢复主机构默认选中状态
  this.mainAgencies.forEach(agency => {
    if (['全国人民代表大会及其常务委员会', '国务院', '国家监察委员会', '最高人民检察院', '最高人民法院'].includes(agency.id)) {
      agency.checked = true;
    } else {
      agency.checked = false;
    }
  });
  
  // 恢复全国人大及其常委会子机构默认选中状态
  this.npcSubAgencies.forEach(item => {
            item.checked = true;  // 确保全选子机构
        });
  
  // 重置地方人大子机构
  this.localSubAgencies.forEach(item => {
    item.checked = false;
  });

  // 重置法律效力位阶选择
  this.legalLevelParams = '';
      this.selectedLegalLevelText = '';
      this.updateSelectedAgencyText();
      this.updatePromulgatingAgency();
      this.legalLevelMain.forEach(level => {
        level.checked = true;  // 将false改为true，确保重置后仍保持全选状态
      });
      this.updateLegalLevelTextAndParams();

  // 关闭下拉框
  this.showMainAgencyDropdown = false;
  this.showSubAgencyDropdown = false;
  this.showLegalLevelDropdown = false;
  this.showSubLegalLevelDropdown = false;
},

    // 新增：确认选项并关闭高级检索界面
    confirmAdvancedOptions() {
      this.showAdvancedOptions = false; // 关闭高级检索界面
      // 可以在这里添加其他需要执行的操作，如立即执行搜索等
    },
    resetSearchState() {
      this.hasSearched = false;      // 标记为未搜索状态
      this.searchResults = [];       // 清空搜索结果
      this.errorMessage = '';        // 清除错误提示
      this.pageInfo = {              // 重置分页信息
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pages: 0
      };
      this.isSearching = false;      // 确保加载状态关闭
    },
    // 更新地方人大选择处理逻辑
    handleLocalAgencySelect() {
      // 选择湖北省时传递正确的模糊匹配参数
      if (this.selectedProvince === '湖北省') {
        this.promulgatingAgency = '*湖北省*';
      }
      // ... 其他省份处理逻辑 ...
    },
    handleProvinceSelect(province) {
      // 获取该省下的所有市级机关
      const cityAgencies = Object.keys(this.cityToProvinceMap)
          .filter(city => this.cityToProvinceMap[city] === province);

      // 将省级机关和对应的市级机关都添加到选中列表
      this.selectedAgencies = [
        province,  // 添加省级机关
        ...cityAgencies  // 添加对应的市级机关
      ];

      // 更新查询参数
      this.promulgatingAgency = this.selectedAgencies.join(',');
      this.updateSelectedAgencyText();
    },

    truncateText(text, maxLength = 500, keyword = '') {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      
      // 优先显示包含关键字的区域
      if (keyword) {
        const keywordIndex = text.toLowerCase().indexOf(keyword.toLowerCase());
        if (keywordIndex > -1) {
          // 关键字前后预留空间，确保关键字可见
          const start = Math.max(0, keywordIndex - 150);
          const end = Math.min(text.length, start + maxLength);
          let result = text.substring(start, end);
          if (start > 0) result = '...' + result;
          if (end < text.length) result += '...';
          return result;
        }
      }
      
      // 默认截断逻辑（保留开头）
      return text.substring(0, maxLength) + '...';
    },
    // 格式化条款上下文（显示开头+关键字片段）
    formatClauseContext(matchedClauses, keyword) {
      const effectiveKeyword = keyword?.trim() || this.searchQuery?.trim() || '';
      if (!effectiveKeyword) return '请输入搜索关键字';
      if (!matchedClauses) return '未找到包含关键字的条款';

      const clauseRegex = /第[零一二三四五六七八九十百千万0-9]+条[\s:　]+[^|]*/g;
      const clauses = matchedClauses.match(clauseRegex) || [];
      const formattedClauses = [];

      const escapedKeyword = effectiveKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const keywordRegex = new RegExp(`(${escapedKeyword})`, 'gi');

      for (const clause of clauses) {
  // 拆分条款号和内容（假设格式为"第X条 内容"）
  const clauseMatch = clause.match(/(第[零一二三四五六七八九十百千万0-9]+条[\s:：　]+)([\s\S]*)/);
  if (!clauseMatch || clauseMatch.length < 3) continue;
  
  const [, clauseTitle, clauseContent] = clauseMatch;
  if (!clauseTitle || !clauseContent) continue;

  const formattedTitle = `<strong>${clauseTitle}</strong>`;

  // 先截取纯文本内容，避免HTML标签干扰
  const textSnippet = this.truncateText(clauseContent, 500, effectiveKeyword);
  
  // 然后对截取后的纯文本进行关键字高亮
  const formattedContent = textSnippet.replace(keywordRegex, '<span class="keyword-highlight">$1</span>');

  // 拼接处理后的条款
  formattedClauses.push(`${formattedTitle} ${formattedContent}`);
}

      return formattedClauses.join('<br>');
    },
    // 切换法律效力位阶主下拉框
    toggleLegalLevelDropdown() {
      this.showLegalLevelDropdown = !this.showLegalLevelDropdown;
      if (this.showSubLegalLevelDropdown) {
        this.showSubLegalLevelDropdown = false;
        this.currentLegalLevel = null;
      }
    },
    // 处理法律效力位阶主选项点击
    handleLegalLevelClick(level) {
      if (!level.hasChildren) { // 无子选项的直接切换选中状态
        level.checked = !level.checked;
        this.updateLegalLevelTextAndParams(); // 更新显示和参数
        return;
      }
      // 有子选项的切换子下拉框显示状态
      if (this.currentLegalLevel === level) {
        this.showSubLegalLevelDropdown = !this.showSubLegalLevelDropdown;
      } else {
        this.currentLegalLevel = level;
        this.showSubLegalLevelDropdown = true;
      }
    },
    // 切换法律效力位阶主下拉框
    toggleLegalLevelDropdown() {
      this.showLegalLevelDropdown = !this.showLegalLevelDropdown;
      if (this.showSubLegalLevelDropdown) {
        this.showSubLegalLevelDropdown = false;
        this.currentLegalLevel = null;
      }
    },
    // 处理子选项点击
    handleSubLegalLevelClick(mainLevel, subItem) {
      if (subItem.id.includes('_all')) { // 处理全选
        const subs = this.legalLevelSub[mainLevel.id];
        const isAllChecked = subItem.checked;
        subs.forEach(item => item.checked = !isAllChecked);
      } else {
        subItem.checked = !subItem.checked;
        this.updateSubLegalLevelAllStatus(mainLevel); // 更新全选状态
      }
      this.updateMainLegalLevelStatus(mainLevel); // 更新主选项状态
      this.updateLegalLevelTextAndParams(); // 更新显示文本和参数
    },
    // 更新子选项全选状态
    updateSubLegalLevelAllStatus(mainLevel) {
      const subs = this.legalLevelSub[mainLevel.id];
      const allItem = subs.find(item => item.id.includes('_all'));
      const otherItems = subs.filter(item => !item.id.includes('_all'));
      allItem.checked = otherItems.every(item => item.checked);
    },

    // 更新主选项选中状态
    updateMainLegalLevelStatus(mainLevel) {
      const subs = this.legalLevelSub[mainLevel.id];
      mainLevel.checked = subs.some(item => item.checked);
    },
    // 更新显示文本和搜索参数
    updateLegalLevelTextAndParams() {
      const selected = [];
      const params = [];

      // 处理无子选项的主项
      this.legalLevelMain.forEach(level => {
        if (!level.hasChildren && level.checked) {
          selected.push(level.name);
          params.push(level.id);
        }
      });

      this.selectedLegalLevelText = selected.join('; ');
      this.legalLevelParams = params.join(',');
    },
    // 切换主下拉框显示状态
    toggleMainAgencyDropdown() {
      this.showMainAgencyDropdown = !this.showMainAgencyDropdown;
      // 当打开主下拉框时，自动显示地方人大及其常委会的子选项
  if (this.showMainAgencyDropdown) {
    const localAgency = this.mainAgencies.find(a => a.id === '地方人大及其常委会');
    if (localAgency) {
      this.currentMainAgency = localAgency;
      this.showSubAgencyDropdown = true;
    }
  } else {
    // 当关闭主下拉框时，关闭子下拉框
    this.showSubAgencyDropdown = false;
    this.currentMainAgency = null;
  }
    },
    handleAgencyCheckboxClick(agency) {
      if (!agency.hasChildren) {
        // 无子机构的直接切换选中状态
        agency.checked = !agency.checked;
        this.updateSelectedAgencyText();
        this.updatePromulgatingAgency();
        return;
      }
      
      // 有子机构的主机构点击复选框时全选/取消全选子机构
      agency.checked = !agency.checked;
      
      // 获取对应的子机构列表
      const subAgencies = agency.id === '全国人民代表大会及其常务委员会' 
        ? this.npcSubAgencies 
        : this.localSubAgencies;
      
      // 全选/取消全选所有子机构
      subAgencies.forEach(item => {
        item.checked = agency.checked;
      });
      
      // 更新显示文本和搜索参数
      this.updateSelectedAgencyText();
      this.updatePromulgatingAgency();
    },
    
    // 处理机构名称点击 - 仅展开/收起子机构
    handleAgencyNameClick(agency) {
      if (!agency.hasChildren) return;
      
      // 切换子下拉框显示状态
      if (this.currentMainAgency === agency) {
        this.showSubAgencyDropdown = !this.showSubAgencyDropdown;
      } else {
        this.currentMainAgency = agency;
        this.showSubAgencyDropdown = true;
      }
    },
    // 处理子机构点击
    handleSubAgencyClick(mainAgency, subItem) {
      // 处理全选
      if (subItem.id === 'npc_all' || subItem.id === 'local_all') {
        const subAgencies = subItem.id === 'npc_all' ? this.npcSubAgencies : this.localSubAgencies;
        const isAllChecked = subItem.checked;

        // 全选/取消全选
        subAgencies.forEach(item => {
          item.checked = !isAllChecked;
        });
      } else {
        subItem.checked = !subItem.checked;
        this.handleSubItemCheck(mainAgency);
      }

      // 更新主机构选中状态
      this.updateMainAgencyCheckStatus(mainAgency);
      // 更新显示文本
      this.updateSelectedAgencyText();
      // 更新搜索参数
      this.updatePromulgatingAgency();
    },
    // 处理子项勾选后更新全选状态
    handleSubItemCheck(mainAgency) {
      const subAgencies = mainAgency.id === 'npc' ? this.npcSubAgencies : this.localSubAgencies;
      const allItem = subAgencies[0]; // 全选是第一个
      const otherItems = subAgencies.slice(1);

      // 检查是否所有子项都被选中
      const allChecked = otherItems.every(item => item.checked);
      allItem.checked = allChecked;
    },
    // 更新主机构的选中状态
    updateMainAgencyCheckStatus(mainAgency) {
      // 修正判断条件：使用主机构实际id匹配
      const subAgencies = mainAgency.id === '全国人民代表大会及其常务委员会'
          ? this.npcSubAgencies
          : this.localSubAgencies; // 地方人大使用原逻辑
      // 检查是否有子项被选中
      const hasChecked = subAgencies.some(item => item.checked);
      mainAgency.checked = hasChecked;

      // 地方人大及其常委会有选中项时保持下拉框打开
      if (mainAgency.id === '地方人大及其常委会' && hasChecked) {
        this.currentMainAgency = mainAgency;
        this.showSubAgencyDropdown = true;
      }
    },
    // 更新显示的文本
    updateSelectedAgencyText() {
      const selected = [];

  // 处理没有子机构的
  this.mainAgencies.forEach(agency => {
    if (!agency.hasChildren && agency.checked) {
      selected.push(agency.name);
    }
  });
  
  // 处理全国人大及其常委会
  const npcAgency = this.mainAgencies.find(a => a.id === '全国人民代表大会及其常务委员会');
  if (npcAgency?.checked) {
    const checkedItems = this.npcSubAgencies.filter(item => item.checked && item.id !== 'npc_all');
    if (checkedItems.length > 0) {
      selected.push(`全国人大及其常委会(${checkedItems.map(item => item.name).join('、')})`);
    }
  }
  
  // 处理地方人大及其常委会
  const localAgency = this.mainAgencies.find(a => a.id === '地方人大及其常委会');
  if (localAgency?.checked) {
    const checkedItems = this.localSubAgencies.filter(item => item.checked && item.id !== 'local_all');
    if (checkedItems.length > 0) {
      selected.push(`地方人大及其常委会(${checkedItems.length}个省份)`);
    }
  }

  this.selectedAgencyText = selected.join('; ');
},
    // 更新搜索用的制定机关参数
    updatePromulgatingAgency(preserveLocalState = false) {
      const values = [];

      // 只有在不保留本地状态且没有地方选中时才重置
      if (!preserveLocalState && !this.localSubAgencies.some(item => item.checked) && !this.isLocalAgencySearch) {
    this.isLocalAgencySearch = false;
    this.localProvinceParams = '';
  }

      // 处理没有子机构的
      this.mainAgencies.forEach(agency => {
        if (!agency.hasChildren && agency.checked) {
          values.push(agency.id);
        }
      });

      // 处理全国人大及其常委会
      const npcAgency = this.mainAgencies.find(a => a.id === '全国人民代表大会及其常务委员会');
      if (npcAgency?.checked) { // 添加可选链检查
        const checkedItems = this.npcSubAgencies.filter(item => item.checked && item.id !== 'npc_all');
        values.push(...checkedItems.map(item => item.id));
      }

      // 处理地方人大及其常委会
      const localAgency = this.mainAgencies.find(a => a.id === '地方人大及其常委会');
  if (localAgency?.checked) {
    const checkedItems = this.localSubAgencies.filter(item => item.checked && item.id !== 'local_all');

    if (checkedItems.length > 0) {
      this.isLocalAgencySearch = true;
      this.localProvinceParams = checkedItems.map(item => item.id).join(',');
      console.log('启用地方人大搜索模式，选中省份:', this.localProvinceParams);
    } else {
      // 如果没有选中任何省份，禁用地方人大搜索模式
      this.isLocalAgencySearch = false;
      this.localProvinceParams = '';
    }
  } else {
    // 如果地方人大及其常委会未被选中，禁用地方人大搜索模式
    this.isLocalAgencySearch = false;
    this.localProvinceParams = '';
  }

      this.promulgatingAgency = values.join(',');
      console.log('当前选中的制定机关参数:', this.promulgatingAgency);
      console.log('是否启用地方人大搜索模式:', this.isLocalAgencySearch);
    },
    // 点击页面其他地方关闭下拉框
    navigateToDetailWithKeyword(lawId, keyword) {
    const encodedParams = {
    keyword: encodeURIComponent(keyword),
    type: this.searchType,
    pageNum: this.pageInfo.pageNum,
    pageSize: this.pageInfo.pageSize,
    searchMode: this.searchMode,
    effectiveStartDate: this.effectiveStartDate || undefined,
    effectiveEndDate: this.effectiveEndDate || undefined,
    promulgationStartDate: this.promulgationStartDate || undefined,
    promulgationEndDate: this.promulgationEndDate || undefined,
    validityStatus: this.validityStatus.join(','),
    promulgatingAgency: encodeURIComponent(this.promulgatingAgency),
    legalLevelParams: encodeURIComponent(this.legalLevelParams),
    // 添加地方人大相关参数
    isLocalAgencySearch: this.isLocalAgencySearch.toString(),
  localProvinceParams: encodeURIComponent(this.localProvinceParams || ''),
    // 新增：保存高级检索界面状态
    showAdvancedOptions: this.showAdvancedOptions
  };
  
  // 过滤undefined值，避免URL中出现"undefined"字符串
  const filteredParams = {};
  Object.keys(encodedParams).forEach(key => {
    // 对于制定机关和法律效力位阶参数，只要不是undefined就保留
    if (key === 'promulgatingAgency' || key === 'legalLevelParams' || key === 'localProvinceParams') {
      if (encodedParams[key] !== undefined) {
        filteredParams[key] = encodedParams[key];
      }
    } else if (encodedParams[key] !== undefined && encodedParams[key] !== '') {
      filteredParams[key] = encodedParams[key];
    }
  });
  
  this.$router.push({
    path: `/detail/${lawId}`,
    query: filteredParams
  });
    },
    navigateToDetail(lawId) {
      // 编码特殊参数，避免URL解析错误
  const encodedParams = {
    keyword: encodeURIComponent(this.searchQuery),
    type: this.searchType,
    pageNum: this.pageInfo.pageNum,
    pageSize: this.pageInfo.pageSize,
    searchMode: this.searchMode,
    // 日期参数单独处理，避免null值
    effectiveStartDate: this.effectiveStartDate || undefined,
    effectiveEndDate: this.effectiveEndDate || undefined,
    promulgationStartDate: this.promulgationStartDate || undefined,
    promulgationEndDate: this.promulgationEndDate || undefined,
    validityStatus: this.validityStatus.join(','),
    promulgatingAgency: encodeURIComponent(this.promulgatingAgency),
    legalLevelParams: encodeURIComponent(this.legalLevelParams),
    // 添加地方人大相关参数
    isLocalAgencySearch: this.isLocalAgencySearch.toString(),
    localProvinceParams: encodeURIComponent(this.localProvinceParams || ''),
    // 新增：保存高级检索界面状态
    showAdvancedOptions: this.showAdvancedOptions
  };
  
  // 过滤undefined值，避免URL中出现"undefined"字符串
  const filteredParams = {};
  Object.keys(encodedParams).forEach(key => {
    // 对于制定机关和法律效力位阶参数，只要不是undefined就保留
    if (key === 'promulgatingAgency' || key === 'legalLevelParams' || key === 'localProvinceParams') {
      if (encodedParams[key] !== undefined) {
        filteredParams[key] = encodedParams[key];
      }
    } else if (encodedParams[key] !== undefined && encodedParams[key] !== '') {
      filteredParams[key] = encodedParams[key];
    }
  });
  
  this.$router.push({
    path: `/detail/${lawId}`,
    query: filteredParams
  });
    },
    showKeywordTooltip(result, event) {
      this.tooltipVisible = true;
      this.currentResult = result;
      this.tooltipX = event.clientX + 10;
      this.tooltipY = event.clientY + 5;
    },
    hideKeywordTooltip() {
      this.tooltipVisible = false;
    },
    async created() {
    const {
    keyword,
    type,
    pageNum,
    pageSize,
    legalLevelParams,
    promulgatingAgency,
    searchMode,
    effectiveStartDate,
    effectiveEndDate,
    promulgationStartDate,
    promulgationEndDate,
    validityStatus,
    isLocalAgencySearch,
    localProvinceParams,
    showAdvancedOptions
  } = this.$route.query;

  // 初始化默认搜索设置
  this.searchType = type || 'title';
  this.pageInfo.pageNum = parseInt(pageNum) || 1;
  this.pageInfo.pageSize = parseInt(pageSize) || 10;
  this.searchMode = searchMode || 'fuzzy'; // 恢复搜索方式
  
  // 恢复日期范围参数
  if (effectiveStartDate) this.effectiveStartDate = effectiveStartDate;
  if (effectiveEndDate) this.effectiveEndDate = effectiveEndDate;
  if (promulgationStartDate) this.promulgationStartDate = promulgationStartDate;
  if (promulgationEndDate) this.promulgationEndDate = promulgationEndDate;
  
  // 恢复时效性状态
  if (validityStatus) {
    this.validityStatus = validityStatus.split(',').map(Number);
  }
  
  // 恢复高级检索界面状态
  this.showAdvancedOptions = showAdvancedOptions === 'true' || false;
  
  // 恢复地方人大相关参数
  this.isLocalAgencySearch = isLocalAgencySearch === 'true' || false;
  this.localProvinceParams = localProvinceParams ? decodeURIComponent(localProvinceParams) : '';
  
  // 从路由参数恢复法律效力位阶选择状态
  if (legalLevelParams) {
    this.restoreLegalLevelSelections(decodeURIComponent(legalLevelParams));
  }
  
  // 检查是否有需要恢复的搜索状态
  const hasSearchState = promulgatingAgency || 
                      this.isLocalAgencySearch || 
                      legalLevelParams ||
                      effectiveStartDate ||
                      effectiveEndDate ||
                      promulgationStartDate ||
                      promulgationEndDate ||
                      validityStatus;

if (hasSearchState) {
      console.log('检测到搜索状态，恢复之前的选择');

      // 从路由参数恢复制定机关选择状态：传递所有必要参数
      if (promulgatingAgency) {
        this.restoreAgencySelections(
          decodeURIComponent(promulgatingAgency),
          this.isLocalAgencySearch,  // 新增：传递地方人大搜索模式状态
          this.localProvinceParams   // 新增：传递选中的省份参数
        );
      } else if (this.isLocalAgencySearch) {
        // 如果只有地方人大搜索模式，也要传递完整参数
        this.restoreAgencySelections(
          '',
          this.isLocalAgencySearch,  // 新增：传递地方人大搜索模式状态
          this.localProvinceParams   // 新增：传递选中的省份参数
        );
      }
    }else {
  // 如果没有搜索状态，使用默认初始化
  console.log('未检测到搜索状态，使用默认设置');
  this.initDefaultAgencySelections();
}
  
  // 如果有关键词参数，执行搜索
  if (keyword) {
    this.searchQuery = keyword;
    await this.handleSearch(false); // 触发搜索
  }
},
initDefaultAgencySelections() {
  // 设置默认选中：全国人大及其常委会全选
  const npcAgency = this.mainAgencies.find(a => a.id === '全国人民代表大会及其常务委员会');
  if (npcAgency) {
    npcAgency.checked = true;
    this.npcSubAgencies.forEach(sub => {
      if (sub.id !== 'npc_all') {
        sub.checked = true;
      }
    });
  }
  
   // 设置其他国家级机构默认选中
  const stateCouncil = this.mainAgencies.find(a => a.id === '国务院');
  const supremeCourt = this.mainAgencies.find(a => a.id === '最高人民法院');
  const supremeProcuratorate = this.mainAgencies.find(a => a.id === '最高人民检察院');
  const supervisoryCommission = this.mainAgencies.find(a => a.id === '国家监察委员会');
  
  if (stateCouncil) stateCouncil.checked = true;
  if (supremeCourt) supremeCourt.checked = true;
  if (supremeProcuratorate) supremeProcuratorate.checked = true;
  if (supervisoryCommission) supervisoryCommission.checked = true;
  
  // 找到地方人大及其常委会机构
  const localAgency = this.mainAgencies.find(a => a.id === '地方人大及其常委会');
  if (localAgency) {
    // 设置地方人大及其常委会的子下拉框默认显示但不选中
    this.currentMainAgency = localAgency;
    this.showSubAgencyDropdown = true;
    // 确保地方人大及其常委会和其子选项都不被选中
    localAgency.checked = false;
    this.localSubAgencies.forEach(sub => {
      if (sub.id !== 'local_all') {
        // 移除所有子选项的checked属性，使其不被选中
        delete sub.checked;
      } else {
        // 设置"全选"选项为未选中
        sub.checked = false;
      }
    });
  }
  
  // 更新搜索参数
  this.updatePromulgatingAgency();
  // 更新显示文本
  this.updateSelectedAgencyText();
},
    async handleSearch(isPagination = false) {
      console.log('当前搜索类型:', this.searchType);
      console.log('当前时效性筛选状态:', this.validityStatus);
      this.errorMessage = '';
      if (!this.searchQuery.trim()) {
        this.errorMessage = '请输入搜索内容';
        return;
      }
      if (!isPagination) {
        this.pageInfo.pageNum = 1;
      }
      this.isSearching = true;
      this.hasSearched = true;
      console.log('hasSearched 状态:', this.hasSearched);
      try {
    console.log('搜索前状态检查:', {
      isLocalAgencySearch: this.isLocalAgencySearch,
      localProvinceParams: this.localProvinceParams,
      promulgatingAgency: this.promulgatingAgency,
      legalLevelParams: this.legalLevelParams
    });
    let filteredLegalLevelParams = this.legalLevelParams || '';
    if (this.searchQuery.includes('&') && this.searchType !== 'both') {
      this.searchType = 'both';
      this.errorMessage = '检测到标题+正文格式，已自动切换搜索类型';
      setTimeout(() => this.handleSearch(isPagination), 1000);
      return;
    }
    const searchParams = {
  query: this.searchQuery.trim(),
  type: this.searchType,
  page: this.pageInfo.pageNum,
  limit: this.pageInfo.pageSize,
  searchMode: this.searchMode,
  effectiveStart: this.effectiveStartDate,
  effectiveEnd: this.effectiveEndDate,
  promulgationStart: this.promulgationStartDate,
  promulgationEnd: this.promulgationEndDate,
  validity: this.validityStatus.map(Number),
  legalLevel: this.legalLevelParams || ''
};
    
  const allAgencies = [];
if (this.promulgatingAgency && this.promulgatingAgency.trim() !== '') {
  allAgencies.push(this.promulgatingAgency);
}

if (this.localProvinceParams && this.localProvinceParams.trim() !== '') {
  const localAgencies = this.localProvinceParams.split(',').map(province => `*${province}`).join(',');
  allAgencies.push(localAgencies);
}

if (allAgencies.length > 0) {
  searchParams.promulgatingAgency = allAgencies.join(',');
}

// 如果启用了地方人大搜索模式，添加省份参数
if (this.isLocalAgencySearch && this.localProvinceParams) {
  searchParams.province = this.localProvinceParams;
}
    
    console.log('最终发送的搜索参数:', searchParams);
    
    const response = await searchApi.advancedSearch(searchParams);

        this.$nextTick(() => {
          console.log('DOM 更新后');
        });
        console.log('完整响应结构:', response);  // 打印完整响应数据
          const pageResult = response.data || {};
          const list = pageResult.list || [];
          list.forEach((item, index) => {
            console.log(`搜索结果第${index + 1}条的 matchedClauses:`, item.matchedClauses);

          });
          this.pageInfo = {
            pageNum: pageResult.pageNum || 1,
            pageSize: pageResult.pageSize || 10,
            total: pageResult.total || 0,
            pages: pageResult.pages || 0
          };
          // 为每个结果添加 matchedClauses 默认值
         const sortedList = list
              .filter(item => item !== null && item !== undefined)
              .map(item => {
                // 确保 matchedClauses 是字符串（后端已保证，此处仅做防御性处理）
                const matchedClauses = typeof item.matchedClauses === 'string' ? item.matchedClauses : '';

                return { ...item, matchedClauses }; // 直接保留字符串
              })
              .filter(item => {
                return true;
              })
              .sort((a, b) => {
                // 第一优先级：有效文件(is_active=1)排在前面
                if (a.is_active === 1 && b.is_active !== 1) return -1;
                if (a.is_active !== 1 && b.is_active === 1) return 1;

                // 第二优先级：按时效性状态排序（尚未生效>已修改>已废止）
                if (a.is_active !== b.is_active) {
                  return a.is_active - b.is_active;
                }

                // 第三优先级：按ID升序排序
                return a.id - b.id;
              });
          this.searchResults = sortedList; // 直接赋值，不需要额外过滤
      } catch (error) {
        console.error('搜索出错:', error);
      } finally {
        this.isSearching = false;
      }
    },
    toggleAdvancedOptions() {
      this.showAdvancedOptions = !this.showAdvancedOptions;
    },
    // 分页方法
    changePage(page) {
      if (page >= 1 && page <= this.pageInfo.pages) {
        this.pageInfo.pageNum = page;
        this.handleSearch(true);
      }
    },
    goToPage() {
      const page = parseInt(this.targetPage, 10);  // 转换为数字
      // 校验页码有效性
      if (isNaN(page) || page < 1 || page > this.pageInfo.pages) {
        this.errorMessage = `请输入1到${this.pageInfo.pages}之间的有效页码`;
        return;
      }
      this.changePage(page);  // 调用已有分页方法跳转
      this.targetPage = '';  // 清空输入框
    }
  }
};
</script>

<style scoped>


.result-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  border: 1px solid #e8e8e8;
}

.result-table th {
  background-color: #f8f9fa;
  padding: 12px;
  text-align: left;
  font-weight: 500;
  border-bottom: 2px solid #e8e8e8;
}

.result-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.result-table tr:hover td {
  background-color: #fafbfc;
  transition: background-color 0.2s;
}

.search-container {
  display: flex;
  align-items: center;
  width: 80%;
  max-width: 800px;
  margin: 160px auto 20px;
}

#search-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px;
  font-size: 16px;
}

.search-btn,
.advanced-btn {
  padding: 12px 16px;
  border: none;
  cursor: pointer;
  line-height: 1;
}
.advanced-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 30px;  /* 增加与上方内容的间距 */
  padding-top: 20px; /* 增加顶部内边距 */
  border-top: 1px solid #f0f0f0; /* 使用更浅的分隔线 */
}

.reset-btn {
  padding: 10px 24px; /* 增大按钮尺寸 */
  border: 1px solid #dcdfe6;
  background-color: white;
  color: #606266;
  border-radius: 6px; /* 使用更大的圆角 */
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px; /* 增大字体 */
}

.reset-btn:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}

.confirm-btn {
  padding: 10px 24px; /* 增大按钮尺寸 */
  border: none;
  background-color: #007BFF;
  color: white;
  border-radius: 6px; /* 使用更大的圆角 */
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px; /* 增大字体 */
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2); /* 添加轻微阴影 */
}

.confirm-btn:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3); /* 增强悬停阴影 */
}

.cancel-btn {
  padding: 10px 24px; /* 增大按钮尺寸 */
  border: 1px solid #dcdfe6;
  background-color: white;
  color: #606266;
  border-radius: 6px; /* 使用更大的圆角 */
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px; /* 增大字体 */
}

.cancel-btn:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3); /* 增强悬停阴影 */
}

.search-btn {
  background-color: #007BFF;
  color: white;
  border-radius: 0;
}

.advanced-btn {
  background-color: #ff0000;
  color: white;
  border-radius: 0 4px 4px 0;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.advanced-options {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 25px 30px; /* 增加内边距 */
  margin: 20px auto;
  max-width: 850px; /* 适当增加宽度 */
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 12px; /* 使用更大的圆角 */
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05); /* 增强阴影效果 */
}
.option-group {
  display: flex;
  align-items: center;
  gap: 20px; /* 增大间距 */
  padding: 16px 0; /* 增加内边距 */
  border-bottom: 1px solid #f5f5f5;
}
.option-group:last-child {
  border-bottom: none;
}
.input-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;  /* 增大输入元素间间距 */
  flex: 1;
}
.checkbox-group {
  gap: 24px;  /* 复选框间距更大 */
}

.advanced-options label {
  white-space: nowrap;  /* 防止文字换行 */
}

.no-results {
  width: 80%;
  max-width: 800px;
  margin: 20px auto;
  padding: 15px;
  text-align: center;
  color: #666;
}

.error-message {
  width: 80%;
  max-width: 800px;
  margin: 10px auto;
  padding: 10px 15px;
  background-color: #fff0f0;
  color: #dc3545;
  border: 1px solid #ffccd5;
  border-radius: 4px;
  text-align: center;
}

.loading {
  width: 80%;
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
  color: #666;
}
.advanced-options .search-range-label:nth-of-type(2) {
  margin-left: 100px; /* 调整此值可改变间距大小 */
}
.advanced-options .search-range-label:nth-of-type(3) {
  margin-left: 0px; /* 调整此值可改变间距大小 */
}
.advanced-options input[type="date"]{
  min-width: 180px;  /* 比原宽度增加20px */
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}
.advanced-options input[type="date"]:focus,
.advanced-options select:focus {
  border-color: #007BFF; /* 聚焦时边框变色 */
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2); /* 添加聚焦光晕 */
}
.advanced-options input[type="date"]:valid {
  color: #000; /* 聚焦或已选择时显示黑色文字 */
}

.advanced-options select {
  padding: 8px 12px; /* 增加内边距 */
  border: 1px solid #dcdfe6;
  border-radius: 6px; /* 使用更大的圆角 */
  font-size: 14px;
  transition: border-color 0.2s; /* 添加过渡效果 */
}

.search-range-label {
  min-width: 110px; /* 增加标签宽度 */
  text-align: right;
  font-weight: 500;
  color: #4e5969; /* 使用更深的颜色 */
  font-size: 14px;
}

.advanced-options input[type="checkbox"][name="validity-status"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border: 2px solid #ccc;
  border-radius: 2px; /* 控制方形圆角程度，0为纯方形 */
  outline: none;
  cursor: pointer;
  margin-right: 6px;
  position: relative;
  top: 0px; /* 微调垂直对齐 */
}
.advanced-options input[type="checkbox"][name="validity-status"]:checked {
  border-color: #680081;
  background-color: #680081;
}

.advanced-options input[type="checkbox"][name="validity-status"]:checked::after {
  content: '✓';
  position: absolute;
  top: -4px;
  left: 0px;
  color: white;
  font-size: 12px; /* 对号大小 */
  font-weight: bold;
}
.pagination {
  width: auto;
  max-width: 800px;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.pagination button {
  padding: 8px 16px; /* 增大点击区域 */
  border: 1px solid #007BFF;
  background-color: white;
  color: #007BFF;
  border-radius: 6px; /* 更圆润的边框 */
  cursor: pointer;
  transition: all 0.2s; /* 增加过渡动画 */
  min-width: 60px; /* 统一按钮宽度 */
}

.pagination button:disabled {
  border-color: #ccc;
  background-color: #f0f6ff;
  color: #999;
  cursor: not-allowed;
}
.pagination button:active:not(:disabled) {
  background-color: #e0f0ff; /* 点击背景色 */
}

.pagination button:disabled {
  border-color: #ddd;
  background-color: #f8f9fa;
  color: #999;
  cursor: not-allowed;
}

.pagination span {
  color: #333;
  font-weight: 500; /* 强化当前页文字 */
  padding: 0 8px;
  white-space: nowrap; /* 防止文字换行 */
}
.results-header {
  display: flex;
  justify-content: center; /* 整体居中 */
  align-items: center; /* 垂直居中对齐 */
  gap: 2px;
  margin: 15px 0; /* 上下边距 */
}
/* 搜索结果标题样式 */
.search-results h3 {
  margin: 10px; /* 消除默认边距 */
  color: #333;
  font-size: 16px;
}
.result-title {
  margin: 0; /* 消除默认边距 */
  color: #333;
  font-size: 16px;
  white-space: nowrap; /* 防止标题换行 */
}
.page-input {
  padding: 8px;
  border: 1px solid #007BFF;
  border-radius: 6px;
  width: 60px;
  text-align: center;
  margin: 0 4px;
}

/* 新增：确定按钮样式 */
.go-btn {
  padding: 8px 16px;
  border: 1px solid #007BFF;
  background-color: white;
  color: #007BFF;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 60px;
}

.go-btn:hover {
  background-color: #e0f0ff;
}

.keyword-tooltip {
  position: absolute;  /* 必须 */
  background: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1000;  /* 确保显示在最上层 */
  max-width: 300px;
  word-wrap: break-word;
}

.agency-selector {
  position: relative;
  flex: 1;
  max-width: 200px;
  margin-left: 8px;
}

.agency-header {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: white;
}

.arrow {
  font-size: 12px;
  color: #666;
}

.main-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 200px;
  border: 1px solid #ccc;
  border-top: none;
  background: white;
  z-index: 100;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.sub-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 200px;
  border: 1px solid #ccc;
  background: white;
  z-index: 101;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* 移除滚动条相关设置 */
  max-height: none;
  overflow-y: visible;
}

/* 全国人大及其常委会和地方人大及其常委会的特殊样式 */
.agency-item.has-children .sub-dropdown {
  /* 增加宽度以确保横长大于竖长 */
  width: 500px;
  min-height: 100px;
  /* 移除最大高度限制，显示所有选项 */
  max-height: none;
  overflow: visible;
  /* 使用弹性布局和换行实现多列显示 */
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 8px;
}
.agency-item.has-children:nth-child(6) .sub-dropdown {
  /* 大幅增加宽度以确保能容纳所有省份 */
  width: 800px;
  /* 确保内边距不会挤压内容 */
  box-sizing: border-box;
}

.agency-item.has-children:nth-child(6) .sub-item {
  /* 调整宽度计算，确保每行能显示更多选项 */
  width: calc(16.666% - 16px); /* 每行显示6个选项 */
  margin: 4px;
  min-height: 36px;
  align-items: center;
}
/* 全国人大及其常委会的特殊样式优化 */
.agency-item.has-children:nth-child(1) .sub-dropdown {
  /* 调整宽度以刚好容纳3个选项，不设置固定宽度，而是根据内容自适应 */
  width: auto;
  min-width: 320px;
  /* 移除最小高度限制，让高度根据内容自适应 */
  min-height: auto;
  /* 添加box-sizing确保内边距不会增加整体尺寸 */
  box-sizing: border-box;
  /* 确保flex布局从顶部开始 */
  align-content: flex-start;
  /* 移除不必要的内边距 */
  padding: 4px;
}

/* 为全国人大及其常委会的子项设置合适的宽度 */
.agency-item.has-children:nth-child(1) .sub-item {
  /* 保持每行3个选项的布局 */
  width: calc(33.333% - 8px);
  /* 减少外边距以减少空白 */
  margin: 2px;
  /* 移除最小高度限制 */
  min-height: auto;
}

/* 针对地方人大及其常委会（选项较多）的特殊处理 */
.agency-item.has-children:nth-child(6) .sub-dropdown {
  width: 600px;
}

.agency-item.has-children:nth-child(6) .sub-item {
  width: calc(20% - 16px);
}

/* 重置法律位阶选择器中可能影响的样式 */
.legal-level-selector .sub-dropdown {
  width: 220px;
  max-height: 300px;
  overflow-y: auto;
  display: block;
}

.legal-level-selector .sub-item {
  width: auto;
  margin: 0;
  border-radius: 0;
}

.agency-item, .sub-item {
  position: relative;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
}
.agency-item.has-children {
  color: #2c3e50;  /* 深灰色，比默认更暗 */
  font-weight: 500;  /* 加粗文字增强区分 */
}

.agency-item:hover, .sub-item:hover {
  background-color: #f5f5f5;
}

.check-icon {
  display: inline-block;
  width: 20px;
  text-align: center;
  color: #007BFF;
  font-weight: bold;
}

.custom-checkbox {
  width: 12px;          /* 方框尺寸 */
  height: 12px;
  border: 2px solid #dcdfe6;  /* 未选中时的边框颜色 */
  border-radius: 2px;   /* 圆角 */
  display: inline-flex; /* 用于居中对号 */
  align-items: center;
  justify-content: center;
  margin-right: 8px;    /* 与文字的间距 */
  flex-shrink: 0;       /* 防止被压缩 */
  color: transparent;   /* 未选中时隐藏对号 */
  cursor: pointer;      /* 鼠标指针样式 */
}

.custom-checkbox.checked {
  background-color: #007BFF;  /* 填充颜色 */
  border-color: #007BFF;      /* 选中时的边框颜色 */
  color: white;               /* 对号颜色 */
}

/* 法律效力位阶选择器样式 */
.legal-level-selector {
  position: relative;
  flex: 1;
  max-width: 200px;
  margin-left: 8px;
}

.legal-level-selector .main-dropdown,
.legal-level-selector .sub-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-top: none;
  background: white;
  z-index: 100;
  max-height: 300px;
  overflow-y: auto;
}

.legal-level-selector .sub-dropdown {
  position: absolute;
  top: 100%;           /* 显示在主选项正下方 */
  left: 0;             /* 与主选项左对齐 */
  width: 220px;        /* 保持宽度 */
  z-index: 101;
  max-height: 300px;
  overflow-y: auto;
}

.row-group {
  display: flex;
  gap: 24px;  /* 两组之间的间距 */
  align-items: center;
  padding: 14px 0;  /* 保持与其他option-group一致的上下内边距 */
  border-bottom: 1px solid #f5f5f5;  /* 统一底部分隔线 */
}

/* 小屏幕适配：窄屏时换行显示 */
@media (max-width: 768px) {
  .row-group {
    flex-wrap: wrap;
  }
  .row-group .option-group {
    flex: 1 1 100%;  /* 窄屏时占满宽度 */
  }
}

.clause-snippet {
  margin: 4px 0;      /* 条款间间距 */
}
.no-results-cell {
  text-align: center;
  color: #666;
  padding: 20px;
}

::v-deep .keyword-highlight {
  color: red !important;
  font-weight: bold;
  background-color: #fff3cd;
  padding: 0 2px;
  border-radius: 2px;
}

.keyword-highlight {
  color: red !important;
  font-weight: bold;
  background-color: #fff3cd;
  padding: 0 2px;
  border-radius: 2px;
}
</style>